var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import AccountUtils from '@popup/steem/utils/account.utils';
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import { KeychainKeyTypes, KeychainKeyTypesLC, } from '@steempro/steem-keychain-commons';
import { PrivateKeyType } from 'src/interfaces/keys.interface';
import { PrivateKey } from '@steempro/steem-tx-js';
import { PrivateKey as BlurtPrivateKey } from '@blurtpro/steem-tx-js';
const getPublicKeyFromPrivateKeyString = (privateKeyS) => {
    try {
        const privateKey = PrivateKey.fromString(privateKeyS);
        const publicKey = privateKey.createPublic();
        return publicKey.toString();
    }
    catch (e) {
        return null;
    }
};
const getPubkeyWeight = (publicKey, permissions) => {
    for (let n in permissions.key_auths) {
        const keyWeight = permissions.key_auths[n];
        const lpub = keyWeight['0'];
        if (publicKey === lpub) {
            return keyWeight['1'];
        }
    }
    return 0;
};
const derivateFromMasterPassword = (username, password, passwordhive, passwordblurt, account, hiveaccount, blurtaccount) => {
    const workingKeys = {};
    // === STEEM ===
    if (account && password) {
        const posting = PrivateKey.fromLogin(username, password, 'posting');
        const active = PrivateKey.fromLogin(username, password, 'active');
        const memo = PrivateKey.fromLogin(username, password, 'memo');
        const postingPub = posting.createPublic().toString();
        const activePub = active.createPublic().toString();
        const memoPub = memo.createPublic().toString();
        const hasPosting = getPubkeyWeight(postingPub, account.posting);
        const hasActive = getPubkeyWeight(activePub, account.active);
        const hasMemo = memoPub === account.memo_key;
        if (hasPosting || hasActive || hasMemo) {
            if (hasPosting) {
                workingKeys.posting = posting.toString();
                workingKeys.postingPubkey = postingPub;
            }
            if (hasActive) {
                workingKeys.active = active.toString();
                workingKeys.activePubkey = activePub;
            }
            if (hasMemo) {
                workingKeys.memo = memo.toString();
                workingKeys.memoPubkey = memoPub;
            }
        }
    }
    // === HIVE ===
    if (hiveaccount && passwordhive) {
        const posting = PrivateKey.fromLogin(username, passwordhive, 'posting');
        const active = PrivateKey.fromLogin(username, passwordhive, 'active');
        const memo = PrivateKey.fromLogin(username, passwordhive, 'memo');
        const postingPub = posting.createPublic().toString();
        const activePub = active.createPublic().toString();
        const memoPub = memo.createPublic().toString();
        const hasPosting = getPubkeyWeight(postingPub, hiveaccount.posting);
        const hasActive = getPubkeyWeight(activePub, hiveaccount.active);
        const hasMemo = memoPub === hiveaccount.memo_key;
        if (hasPosting || hasActive || hasMemo) {
            if (hasPosting) {
                workingKeys.postinghive = posting.toString();
                workingKeys.postingPubkeyhive = postingPub;
            }
            if (hasActive) {
                workingKeys.activehive = active.toString();
                workingKeys.activePubkeyhive = activePub;
            }
            if (hasMemo) {
                workingKeys.memohive = memo.toString();
                workingKeys.memoPubkeyhive = memoPub;
            }
        }
    }
    // === BLURT ===
    if (blurtaccount && passwordblurt) {
        const posting = BlurtPrivateKey.fromLogin(username, passwordblurt, 'posting');
        const active = BlurtPrivateKey.fromLogin(username, passwordblurt, 'active');
        const memo = BlurtPrivateKey.fromLogin(username, passwordblurt, 'memo');
        const postingPub = posting.createPublic().toString();
        const activePub = active.createPublic().toString();
        const memoPub = memo.createPublic().toString();
        const hasPosting = getPubkeyWeight(postingPub, blurtaccount.posting);
        const hasActive = getPubkeyWeight(activePub, blurtaccount.active);
        const hasMemo = memoPub === blurtaccount.memo_key;
        if (hasPosting || hasActive || hasMemo) {
            if (hasPosting) {
                workingKeys.postingblurt = posting.toString();
                workingKeys.postingPubkeyblurt = postingPub;
            }
            if (hasActive) {
                workingKeys.activeblurt = active.toString();
                workingKeys.activePubkeyblurt = activePub;
            }
            if (hasMemo) {
                workingKeys.memoblurt = memo.toString();
                workingKeys.memoPubkeyblurt = memoPub;
            }
        }
    }
    // Ritorna solo se almeno una chiave è valida
    return Object.keys(workingKeys).length > 0 ? workingKeys : null;
};
const hasKeys = (keys) => {
    return keysCount(keys) > 0;
};
const keysCount = (keys) => {
    return keys ? Object.keys(keys).length : 0;
};
const hasActive = (keys) => {
    return keys.active !== undefined;
};
const hasPosting = (keys) => {
    return keys.posting !== undefined;
};
const hasMemo = (keys) => {
    return keys.memo !== undefined;
};
const isAuthorizedAccount = (key) => {
    return KeysUtils.getKeyType(null, key) === PrivateKeyType.AUTHORIZED_ACCOUNT;
};
const isKeyActiveOrPosting = (key, account) => __awaiter(void 0, void 0, void 0, function* () {
    const localAccount = yield AccountUtils.getAccountFromLocalStorage(account.name);
    if ((localAccount === null || localAccount === void 0 ? void 0 : localAccount.keys.active) === key) {
        return KeychainKeyTypes.active;
    }
    else {
        return KeychainKeyTypes.posting;
    }
});
const isUsingMultisig = (key, transactionAccount, initiatorAccountName, method) => {
    const publicKey = KeysUtils.getPublicKeyFromPrivateKeyString(key === null || key === void 0 ? void 0 : key.toString());
    switch (method) {
        case KeychainKeyTypesLC.active: {
            const accAuth = transactionAccount.active.account_auths.find(([auth, w]) => auth === initiatorAccountName);
            const keyAuth = transactionAccount.active.key_auths.find(([keyAuth, w]) => keyAuth === publicKey);
            if ((accAuth && accAuth[1] < transactionAccount.active.weight_threshold) ||
                (keyAuth && keyAuth[1] < transactionAccount.active.weight_threshold)) {
                return true;
            }
            return false;
        }
        case KeychainKeyTypesLC.posting:
            {
                const accAuth = transactionAccount.posting.account_auths.find(([auth, w]) => auth === initiatorAccountName);
                const keyAuth = transactionAccount.posting.key_auths.find(([keyAuth, w]) => keyAuth === publicKey);
                if ((accAuth &&
                    accAuth[1] < transactionAccount.posting.weight_threshold) ||
                    (keyAuth && keyAuth[1] < transactionAccount.posting.weight_threshold)) {
                    return true;
                }
            }
            return false;
    }
    return true;
};
const getKeyReferences = (keys) => {
    return SteemTxUtils.getData('condenser_api.get_key_references', [keys]);
};
const getKeyType = (privateKey, publicKey, transactionAccount, initiatorAccount, method) => {
    if (transactionAccount &&
        initiatorAccount &&
        method &&
        KeysUtils.isUsingMultisig(privateKey, transactionAccount, initiatorAccount.name, method)) {
        return PrivateKeyType.MULTISIG;
    }
    else if (publicKey === null || publicKey === void 0 ? void 0 : publicKey.toString().startsWith('@')) {
        return PrivateKeyType.AUTHORIZED_ACCOUNT;
    }
    else {
        return PrivateKeyType.PRIVATE_KEY;
    }
};
const isExportable = (privateKey, publicKey) => {
    if (privateKey && publicKey) {
        const keyType = KeysUtils.getKeyType(privateKey, publicKey);
        if (keyType === PrivateKeyType.PRIVATE_KEY ||
            keyType === PrivateKeyType.AUTHORIZED_ACCOUNT)
            return true;
    }
    else {
        return false;
    }
};
const checkWrongKeyOnAccount = (key, value, accountName, extendedAccount, foundWrongKey, skipKey) => {
    if (!skipKey && key.includes('Pubkey') && !String(value).includes('@')) {
        const keyType = key.split('Pubkey')[0];
        if (keyType === KeychainKeyTypesLC.active ||
            keyType === KeychainKeyTypesLC.posting) {
            if (!extendedAccount[keyType].key_auths.find((keyAuth) => keyAuth[0] === value)) {
                foundWrongKey[accountName].push(keyType);
            }
        }
        else if (keyType === KeychainKeyTypesLC.memo) {
            if (extendedAccount['memo_key'] !== value) {
                foundWrongKey[accountName].push(keyType);
            }
        }
    }
    return foundWrongKey;
};
export const KeysUtils = {
    isAuthorizedAccount,
    getPublicKeyFromPrivateKeyString,
    getPubkeyWeight,
    derivateFromMasterPassword,
    hasKeys,
    keysCount,
    hasActive,
    hasPosting,
    hasMemo,
    isUsingMultisig,
    getKeyReferences,
    getKeyType,
    isExportable,
    checkWrongKeyOnAccount,
    isKeyActiveOrPosting,
};
